"use client";

import { Button } from "@/components/ui/button";

export function PrintGuide() {
  return (
    <Button variant="outline" onClick={() => window.print()}>
      Print this guide
    </Button>
  );
}
